import React, { useState } from "react";
import { Plus, Minus } from "lucide-react"; // icon library
import teamdis from "../img/teamdis.jpg";

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What services does SecurXpert provide?",
      answer:
        "We provide IT Solutions, Web & Software Development Services, Business Process Services, Staffing, AI & Data Analytics Solutions, Training & Placement.",
    },
    {
      question: "Do you offer custom software development?",
      answer:
        "Yes, we specialize in building scalable and tailored software solutions as per your business requirements.",
    },
    {
      question: "How do I get in touch for a quote or project inquiry?",
      answer:
        "You can fill out our contact form at the bottom of the page or call us at the number listed. We typically respond within 24 hours.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="relative bg-gray-50 overflow-hidden py-16 px-6 lg:px-12">
      {/* subtle background pattern */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/circuit-board.png')] opacity-10"></div>

      <div className="relative max-w-7xl mx-auto grid lg:grid-cols-2 gap-10 items-center">
        {/* LEFT CONTENT */}
        <div>
          <p className="text-blue-600 uppercase tracking-wide font-semibold text-sm mb-2">
            Frequently Ask Question
          </p>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-8 leading-snug">
            Get Quick Answers To Common <br />
            Queries About Our Services.
          </h2>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white shadow-sm hover:shadow-md transition-all rounded-xl"
              >
                <button
                  className="w-full flex justify-between items-center px-6 py-5 text-left font-semibold text-gray-900 text-lg"
                  onClick={() => toggleFAQ(index)}
                >
                  {faq.question}
                  {activeIndex === index ? (
                    <Minus className="text-blue-600 w-5 h-5" />
                  ) : (
                    <Plus className="text-blue-600 w-5 h-5" />
                  )}
                </button>

                <div
                  className={`overflow-hidden transition-all duration-500 ${
                    activeIndex === index ? "max-h-40 pb-4" : "max-h-0"
                  }`}
                >
                  <p className="px-6 text-gray-700 leading-relaxed text-base">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="flex justify-center">
          <img
            src= {teamdis}
            alt="Team discussion"
            className="rounded-2xl shadow-xl w-full max-w-md lg:max-w-lg object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
